import Vue from 'vue';
import store from './../../store';
import getlistentries from './getlistentries';

const DELLISTENTRY_URL = '/api/v1/lists/';

// When the request succeeds
// const successDelListEntry = (response) => {
const successDelListEntry = () => {
  // store.dispatch('getURLLookup', response.data);
  // console.log(response);
  // console.log('x');
  // console.log(getlistentries);
  // console.log('x');
  //
  getlistentries(store.state.lists.listentries_list_id,
    store.state.lists.listentries_pageinfo.thispage_number,
    store.state.lists.listentries_pageinfo.pagesize,
    0);
  // Vue.router.push({
  //   name: 'home.index',
  // });
  // return lookupResponse.data;
};

// const successDelListEntry = (response) => {
//   return response.data;
// };

// When the request fails
const failedDelListEntry = () => {
};

export default (listid, entryid) => {
  const axiosOptions = {
    timeout: 5000,
    headers: { 'X-Auth-Token': localStorage.getItem('jwt') },
    maxRedirects: 0,
    withCredentials: false,
  };
  const thisurl = `${DELLISTENTRY_URL}${listid}/entries/${entryid}`;

  Vue.$http.delete(thisurl, axiosOptions)
   .then((response) => {
     successDelListEntry(response);
    //  successDelListEntry(response);
   })
   .catch((error) => {
     failedDelListEntry(error);
   });
};



// WEBPACK FOOTER //
// ./src/app/services/list/dellistentry.js